import React, { Fragment, useState } from 'react'
import InfiniteList from './InfiniteList';
import Item from './Item';
import Loading from './Loading';


function Tab({ items = [], load , keyList }) {
    const [tab, setTab] = useState('all');
    const Content = () => {
        return (
            <InfiniteList keyList={keyList} >
                {
                    load ?
                        <Loading className="my-3" height={120} count={3} radius={10} />
                        :
                        tab == 'safe' ?
                            items && items.filter((item) => item.type === 'safe').map((item, i) => {
                                return <Item item={item} key={i} link={"/item/" + item.id} />;
                            })
                            :
                            items && items.map((item, i) => {
                                return <Item item={item} key={i} link={"/item/" + item.id} />;
                            })
                }
            </InfiniteList>
        );

    }

    return (
        <Fragment>
            <div className="tabs">
                <div className="row">
                    <div style={{ cursor: "pointer" }} className={tab == "all" ? "col-6 text-center py-3 active" : "col-6 text-center py-3"} onClick={() => setTab("all")}>
                        همه اگهی ها
                    </div>
                    <div style={{ cursor: "pointer" }} className={tab == "safe" ? "col-6 text-center py-3 active" : "col-6 text-center py-3"} onClick={() => setTab("safe")}>
                        خرید امن
                    </div>
                </div>
            </div>
            <Content />
        </Fragment>
    )
}

export default Tab